import React from 'react';
import {
  CheckBoxComp,
  RadioButComp,
  TextareaFieldComp,
  ErrorTextComp
} from '../../../inputs/fields.component';
import GoalServices from '../../../../services/goal.services';
import PermissionComp from './permission.component';
import { reactLoader, removeReactLoader, autoResizeTextArea, constructNestedKRPayload } from '../../../../utils/common.js';
import DropdownComp from '../../../dropdown/dropdown';
import JiraIntegrationPopup from '../jiraIntegrationPopup';
import DeleteCommonModal from '../../../../components/deleteCommonModal.component';
import RetainUpdateModal from '../../../../components/retainUpdateModal.component';
import KrAlignDependance from '../../../../components/okr/wizard/key_results/krAlignDependence';
import { withTranslation } from 'react-i18next';
import NestedInlineComp from "./NestedInline.component";
import AddKrTag from "../../../../krTags/components/addkrTag.component"
import Customokr from "../../../custom_fields/customobj/Customokr";
import KrRelationshipWrapper from './krRelationshipWrapper';
import { AddFinancialTargetsButton } from '../AddFinancialTargetsButton';
class JiraPostLogin extends React.Component {
  constructor(props) {
    super(props);
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
    this.state = {
      jira: {
        ...this.props.jira,
        instances: [],
        jiraRepoData:
          this.props.jira.jiraRepoData.length > 0
            ? this.props.jira.jiraRepoData
            : this.props.jiraRepoData,
        checkRepos: this.props.item
          ? this.props.item.metricJira
            ? this.props.item.metricJira.ids
              ? this.props.item.metricJira.ids.length > 0
                ? this.props.item.metricJira.ids // add ihnstance name?
                : []
              : []
            : []
          : [],
      },
      selectedInstance: null,
      selectedType:
        this.props.item && this.props.item.metricJira
          ? this.props.item.metricJira.qtype
            ? this.props.item.metricJira.qtype
            : 'basic'
          : 'basic',
      jqlSelectedType:
        this.props.item && this.props.item.metricJira
          ? this.props.item.metricJira.progress
            ? this.props.item.metricJira.progress == 'quantity'
              ? 'quantity'
              : 'percentage'
            : 'percentage'
          : 'percentage',
      activeSprints: this.props.item
        ? this.props.item.metricJira
          ? this.props.item.metricJira.active_sprint
            ? this.props.item.metricJira.active_sprint == '1'
            : false
          : false
        : false,
      errors: {},
      jqlQCompContent:
        this.props.item && this.props.item.metricJira
          ? this.props.item.metricJira.qcomplete
            ? this.props.item.metricJira.qcomplete.length > 0
              ? this.props.item.metricJira.qcomplete
              : ''
            : ''
          : '',
      jqlQInCompContent:
        this.props.item && this.props.item.metricJira
          ? this.props.item.metricJira.qincomplete
            ? this.props.item.metricJira.qincomplete.length > 0
              ? this.props.item.metricJira.qincomplete
              : ''
            : ''
          : '',
      exclude: this.props.item
        ? this.props.item.progress_consider
          ? !!((this.props.item.progress_consider == '0' || this.props.item.progress_consider === false))
          : false
        : false,
      jqlCompleteValidated: false,
      jqlInCompleteValidated: false,
      jqlCompleteSpinner: this.props.item && this.props.item.metricJira &&
        this.props.item.metricJira.qtype == "jql" ? true : false,
      jqlInCompleteSpinner: this.props.item && this.props.item.metricJira &&
        this.props.item.metricJira.qtype == "jql" ? true : false,
      jqlCompleteTotalCount: 0,
      jqlInCompleteTotalCount: 0,
      permissionHelpPopUp: false,
      permissionstate:
        this.props.item && this.props.item.permission
          ? this.props.item.permission.split(',').map(Number)
          : this.props.goalDetails.type == 1 ? [8] : [10],
      teamPermissionSelected:
        this.props.item && this.props.item.permission_teams
          ? this.props.item.permission_teams
          : [],
      bizPermissionSelected:  this.props.item && this.props.item.permission_biz ? this. props.item.permission_biz : [],
      showPopup: false,
      confirmPopup: false,
      externalSource: false,
      titleRetain: "",
      contentRetain: "",
      krAlingSelected: this.props.item &&
        this.props.item.kr_aligns !== undefined &&
        this.props.item.kr_aligns.length > 0
        ? this.props.item.kr_aligns
        : [],
      krDependenciesSelected: this.props.item &&
        this.props.item.kr_dependent !== undefined &&
        this.props.item.kr_dependent.length > 0
        ? this.props.item.kr_dependent
        : [],
      tags: [],
      selectedTypeOpt:'',
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      customInputData:[],
      isCustomSave:[],
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : []
    };
    
    this.changeRadio = this.changeRadio.bind(this);
    this.changeJqlRadio = this.changeJqlRadio.bind(this);
    // this.changeRepoSelection = this.changeRepoSelection.bind(this);
    this.onProjectSelecteion = this.onProjectSelecteion.bind(this);
    this.onJqlChange = this.onJqlChange.bind(this);
    this.onDoneQueryChange = this.onDoneQueryChange.bind(this);
    this.validateJiraKr = this.validateJiraKr.bind(this);
    this.onqCompleteOutsideClick = this.onqCompleteOutsideClick.bind(this);
    this.handleFontChangeTextOne = this.handleFontChangeTextOne.bind(this);
    this.handleFontChangeTextTwo = this.handleFontChangeTextTwo.bind(this);
    this.changeExclude = this.changeExclude.bind(this);
    this.changeActiveSprint = this.changeActiveSprint.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.GoalServices = new GoalServices();
    this.permissionData = this.permissionData.bind(this);
    this.teamPermissionData = this.teamPermissionData.bind(this);
    this.formatInstancesForDropdown = this.formatInstancesForDropdown.bind(this);
    this.handleInstanceChange = this.handleInstanceChange.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.onActiveSprintChange = this.onActiveSprintChange.bind(this);
    this.updateInstances = this.updateInstances.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.saveItems = this.saveItems.bind(this);
    this.saveAlignArr = this.saveAlignArr.bind(this);
    this.saveDependentArr = this.saveDependentArr.bind(this);
    this.changeRadioOpt = this.changeRadioOpt.bind(this);
    this.updateTags = this.updateTags.bind(this);
    this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    this.renderError = this.renderError.bind(this);

    this.validateJiraKrCompleted = this.validateJiraKrCompleted.bind(this);;
  }

  componentDidMount() {
    this.props.kpiRef(this)
    document.addEventListener('mousedown', this.onqCompleteOutsideClick);
    if (this.state.selectedType == 'jql') {
      this.firstTextArea.refs.qCompVal.value.length > 80 && autoResizeTextArea(this.firstTextArea.refs.qCompVal);
      this.secondTextArea.refs.qInCompVal.value.length > 80 && autoResizeTextArea(this.secondTextArea.refs.qInCompVal);
    }

    reactLoader();
    this.GoalServices.getAllInstances({
      app: 'jira',
    })
      .then((res) => {
        removeReactLoader();
        if (res && res.data && res.data.data) {
          const formattedData = this.formatInstancesForDropdown(res.data.data);
          let selectedInstance;
          // Find the formatted instance in the results
          // If not found, that means user is either creating a new kr
          // or user disconnected the existing instance, in which case
          // default to first instance found.

          if (Object.keys(this.state.jira.metricObj).length && this.state.jira.metricObj.instance_url) {
            selectedInstance = formattedData.find((instances) => {
              return instances.belong_to === this.state.jira.metricObj.instance_url;
            });
            if (!selectedInstance) {
              // Include the disconnected instance in the dropdown menu, but note it as invalid
              selectedInstance = {
                belong_to: this.state.jira.metricObj.instance_url,
                name: this.state.jira.metricObj.instance_url,
                token_state: 'invalid',
                value: formattedData.length,
              };
              formattedData.push(selectedInstance);
            }
          }
          if (!selectedInstance) {
            selectedInstance = res.data.data[0];
          }
          this.setState({
            jira: {
              ...this.state.jira,
              instances: formattedData,
            },
            selectedInstance,
          })
        } else {
          removeReactLoader();
          this.setState({
            ...this.state.errors,
            instances: true
          })
        }
      })
      .catch((e) => {
        removeReactLoader();
        this.setState({
          ...this.state.errors,
          instances: true
        })
      });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // 2 api calls, one to get projects and one to get jql numbers if type is jql
    if (this.state.selectedInstance !== prevState.selectedInstance) {
      reactLoader();
      this.GoalServices.getExtProjects({
        app: "jira",
        metric_id: 1,
        instance_url: this.state.selectedInstance.belong_to
      }).then((response) => {
        removeReactLoader();
        if (response && response.data && response.data.data) {
          this.setState({
            jira: { ...this.state.jira, jiraRepoData: response.data.data }
          })
        } else {
          this.setState({
            errors: { ...this.state.errors, projects: true }
          })
        }
      }).catch((err) => {
        removeReactLoader();
        this.setState({ ...this.state.errors, projects: true });
        console.log(err);
      });
    }

    if (this.state.selectedInstance !== prevState.selectedInstance &&
      this.state.selectedType === "jql" && this.state.jqlQCompContent.length &&
      this.state.jqlQInCompContent.length) {
      this.GoalServices.getQueryValidationforJira({
        qcomplete: this.state.jqlQCompContent,
        qincomplete: this.state.jqlQInCompContent,
        progress: this.state.jqlSelectedType,
        instance_url: this.state.selectedInstance.belong_to
      }, { timeout: 60000 }).then(response => {
        if (response && response.data && response.data.data) {
          const { qincomplete, qcomplete } = response.data.data;
          if (qincomplete && qincomplete.status == "success" &&
            qcomplete && qcomplete.status == "success") {
            this.setState({
              jqlCompleteValidated: true,
              jqlInCompleteValidated: true,
              jqlCompleteSpinner: false,
              jqlInCompleteSpinner: false,
              jqlInCompleteTotalCount: qincomplete.totalCount ?
                qincomplete.totalCount : 0,
              jqlCompleteTotalCount: qcomplete.totalCount ?
                qcomplete.totalCount : 0
            });
          } else {
            this.setState({
              jqlCompleteValidated: false,
              jqlInCompleteValidated: false,
              jqlCompleteSpinner: false,
              jqlInCompleteSpinner: false,
              errors: {
                ...this.state.errors,
                qCompleteError: true,
                qInCompleteError: true,
                jql: true
              }
            })
          }
        }
      }).catch((error) => {
        this.setState({
          jqlCompleteValidated: false,
          jqlInCompleteValidated: false,
          jqlCompleteSpinner: false,
          jqlInCompleteSpinner: false,
          errors: {
            ...this.state.errors,
            jql: true
          }
        })
      });
    };
  }

  componentWillUnmount() {
		this.props.kpiRef(null)
    document.removeEventListener('mousedown', this.onqCompleteOutsideClick);
  }

  changeRepoSelection = (e, item) => {
    e.stopPropagation();
    const { checkRepos } = this.state.jira;
    const existingChecklist = this.state.jira.checkRepos;
    let result;
    if (checkRepos.find((val) => val == item.project_id)) {
      result = checkRepos.filter((val) => val != item.project_id);
      this.setState({
        jira: {
          ...this.state.jira,
          checkRepos: result,
        },
      });
    } else {
      checkRepos.push(item.project_id);
      this.setState({
        jira: {
          ...this.state.jira,
          checkRepos,
        },
      });
    }

    if (this.state.jira && this.state.jira.checkRepos.length > 0) {
      this.setState({
        errors: {
          ...this.state.errors,
          projectSelectionErr: false,
        },
      });
    }
  }

  changeActiveSprint(e) {
    this.setState({ activeSprints: e.target.checked });
  }

  changeExclude(e) {
    this.setState({ exclude: e.target.checked });
  }

  changeRadio(e) {
    const valueToSet = e.target.id == 'jiraRadioPerc' ? 'basic' : 'jql';
    this.setState({
      selectedType: valueToSet,
    });
  }

  changeJqlRadio(e) {
    const valueToSet = e.target.id == 'quantity' ? 'quantity' : 'percentage';
    this.setState({
      jqlSelectedType: valueToSet,
    });
  }

  handleOptionChange(event) {
    event.stopPropagation();
    this.setState({
      selectedType: event.target.value,
    });
  }

  onProjectSelecteion(e) {
    e.target.checked;
  }


  onJqlChange(e) {
    autoResizeTextArea(this.firstTextArea.refs.qCompVal);
    this.setState({
      errors: {
        ...this.state.errors,
        qCompleteError: false,
      },
      jqlCompleteSpinner: false,
      jqlQCompContent: '',
      jqlCompleteValidated: false,
      // jqlQInCompContent: "",
      // jqlInCompleteValidated: false
    });
  }

  onDoneQueryChange(e) {
    autoResizeTextArea(this.secondTextArea.refs.qInCompVal);
    this.setState({
      errors: {
        ...this.state.errors,
        qInCompleteError: false,
      },
      jqlInCompleteSpinner: false,
      jqlQInCompContent: '',
      jqlInCompleteValidated: false,
    });
  }

  onActiveSprintChange(e) {
    this.setState({ activeSprints: true });
  }

  permissionData(perData) {
    this.setState({
      permissionstate: perData,
    });
  }

  teamPermissionData(teamPerData) {
    this.setState({
      teamPermissionSelected: teamPerData,
    });
  }

  bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }


  validateJiraKrCompleted(callback = null, data = {}) {
    if (callback && typeof callback === 'function') {
      callback(data);
    } else {
      this.props.closeKrRightPane(true);
    }
  }

  validateJiraKr(callback = null) {
    const errors = {};
    const datasets = {};
    this.isSaveCustom(this.state.customInputData)
    this.setState({isCustomSave:[]})

    if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0  ){
      errors["customokr"] = `Please enter required field`;
      this.setState({isCustomSave:this.state.isRequirdCustomOkr})
    }
    if (this.state.jira.jiraRepoData && this.state.jira.jiraRepoData.length > 0) {
      this.state.jira.jiraRepoData.map((val) => {
        datasets[val.project_id] = val.project_name;
      });
    }
    const metricName = this.props.krText;
    if (
      typeof metricName === 'undefined'
      || metricName == null
      || metricName == ''
    ) {
      errors.metricName = true;
      this.props.showMetricNameErr();
    }
    if (this.state.jira.checkRepos.length === 0) {
      if (this.state.selectedType === 'basic') {
        errors.projectSelectionErr = true;
      }
    }
    if (!this.state.jqlCompleteValidated) {
      if (this.state.selectedType === 'jql') {
        errors.qCompleteError = true;
      }
    }
    if (!this.state.jqlInCompleteValidated) {
      if (this.state.selectedType === 'jql') {
        errors.qInCompleteError = true;
      }
    }

    const realErrorState = Object.keys(this.state.errors).filter((val) => val === true).length > 0;
    if (Object.keys(errors).length || realErrorState) {
      this.setState({
        errors: {
          ...this.state.errors,
          ...errors,
        },
      });
      if (errors && errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
      } else if (errors.projectSelectionErr) {
        $('.krRightPaneContent').parent().animate({ scrollTop: $('.krRightPaneContent')[0].scrollHeight - 150 });
      } else if (errors.qCompleteError || errors.qInCompleteError) {
        $('.krRightPaneContent').parent().animate({ scrollTop: $('.krRightPaneContent')[0].scrollHeight - 400 });
      }
    } else {
      if(this.props.item.source != 8 && this.props.item.source == 1){        
        this.setState({
          externalSource: true ,       
          titleRetain: "",
          contentRetain: "",
        })
      }else if ((this.props.item.source != 8 || (this.props.item.source == 8 && this.props.item.ext_app_id != 5)) && this.props.addEditFlag) {
        this.setState({
          confirmPopup: true
        })
      } else {
        const params = {};
        params.ext_app_id = '5';
        params.ext_source_name = metricName;
        params.description = $("#metric-name-note").val();
        params.source = '8';
        params.real_owner = this.props.realOwner.id;
        let coOwners = this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [];
			  params.coOwners = coOwners.length > 0 ? Array.prototype.map
			     .call(coOwners, s => s.id)
			     .toString() : '';
        params.progress_consider = this.state.exclude ? 0 : 1;
        params.active_sprint = this.state.activeSprints ? 1 : 0;
        params.instance_url = this.state.selectedInstance.belong_to;

        let teaMperArr = [], bizPerArr = [];
        if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
          const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
					if (Array.isArray(permission_teams) && permission_teams.length) {
						teaMperArr = permission_teams.map(val => val.id);
					}
					if (Array.isArray(permission_biz) && permission_biz.length) {
						bizPerArr = permission_biz.map(val => val.id);
					}
        } else {
          teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
          bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
        }
        params.permission_teams = teaMperArr;
        params.permission_biz = bizPerArr;

        if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
          params.permission = this.props.goalDetails.permission;
        } else {
          params.permission = Array.prototype.map
            .call(this.state.permissionstate, (s) => s)
            .toString(); // "A,B,C";
        }

        if (this.props.item && this.props.item.id) {
          params.id = this.props.item.id;
        }
        if (this.state.selectedType == 'jql') {
          params.ext_source_jira = {
            qcomplete:
              this.state.jqlQCompContent.length > 0
                ? this.state.jqlQCompContent
                : '',
            qincomplete:
              this.state.jqlQInCompContent.length > 0
                ? this.state.jqlQInCompContent
                : '',
            qprogress: this.state.jqlSelectedType,
            qtype: this.state.selectedType,
          };
        } else if (this.state.selectedType == 'basic') {
          params.project_names = datasets;
          params.project_ids = this.state.jira.checkRepos;
          params.ext_source_jira = {
            qcomplete: '',
            qincomplete: '',
            qprogress: '',
            qtype: this.state.selectedType,
          };
        }
        let krAlignSel = this.state.krAlingSelected;
        let dependentKrsSel = this.state.krDependenciesSelected;
        let krAligns = [];
        let dependentKrs = [];

        if (Object.keys(krAlignSel).length > 0) {
          krAlignSel.map(item => {
            krAligns.push(item.id);
          });
        }

        if (Object.keys(dependentKrsSel).length > 0) {
          dependentKrsSel.map(item => {
            dependentKrs.push(item.id);
          });
        }
        params["nested_krs"] = constructNestedKRPayload(this.props);
        params.krAligns = krAligns;
        let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
        let tagids=this.state.tags.length ? this.state.tags : ['']
        let finalTagsIds = [...nlpIds,...tagids]
        params.krTagIds = finalTagsIds;
        params.dependentKr = dependentKrs;
        const goalId = this.props.goalDetails.id;
        const { actions } = this.props;
        if(this.props.isChildKr && this.props.fromParentKr){
          params.duration = this.props.childKrDuration;
          params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
          if(this.props.item.parent){
            params.parent = this.props.item.parent;
          }
          this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
        } else if(this.props.mitChildKr){
          params.duration = this.props.childKrDuration;
          params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
          params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
          params.end_date = this.props.item.end_date;
          params.start_date = this.props.item.start_date;
          params.target = this.props.item.target  || 0;
          params.name = metricName;
          // params.checkRepos = this.state.jira.checkRepos;
          if(this.state.selectedType == 'jql'){
            params.metricJira = {
              qcomplete:
                this.state.jqlQCompContent.length > 0
                  ? this.state.jqlQCompContent
                  : '',
              qincomplete:
                this.state.jqlQInCompContent.length > 0
                  ? this.state.jqlQInCompContent
                  : '',
              qprogress: this.state.jqlSelectedType,
              progress: this.state.jqlSelectedType,
              qtype: this.state.selectedType,
            };
          } else if(this.state.selectedType == 'basic'){
            params.metricJira = { 
              ids : this.state.jira.checkRepos,
              active_sprint : params.active_sprint,
              qtype: this.state.selectedType
            };
          }
          this.props.saveQuarterlyKR(params, this.props.mitIndex);
          this.validateJiraKrCompleted(callback, params);
          // this.props.closeKrRightPane();
        } else{
          if(this.props.item.parent){
            params.start_date = this.props.childKrDuration.start ;
            params.end_date = this.props.childKrDuration.end;
            params.parent = this.props.item.parent;
          }
          params.customField=JSON.stringify(this.props.customFieldsData);
          reactLoader();
          this.GoalServices.addEditKr({ goalId, metric: params }).then(
            (response) => {
              removeReactLoader();
              if (response.data.data) {
                this.setState({ confirmPopup: false , externalSource : false});
                if (!this.props.onlyMetEdit) {
                  const result = response.data.data;
                  let krWeightage = null;
                  if (result.krWeightage) {
                    krWeightage = result.krWeightage;
                    delete result.krWeightage;
                  }
                  if(result.parent){
                    actions.addUpdateNestedKr(result)
                  }else{
                    actions.addNewKr(response.data.data);
                  }
                  if (krWeightage) {
                    this.props.MetricChangeWeight(krWeightage);
                  }
                }
                // this.GoalServices.triggerGoalMetricDetails({ goalId });
                // this.props.closeKrRightPane(true);
                this.validateJiraKrCompleted(callback, response.data.data);
              }
            },
          );
        }
      }
    }
  }

  exitDeleteModal() {
    this.setState({ confirmPopup: false, externalSource:false });
  }

  saveItems() {
    let errors = {};
    let datasets = {};
    let _this = this;
    if (this.state.jira.jiraRepoData && this.state.jira.jiraRepoData.length > 0) {
      this.state.jira.jiraRepoData.map(val => {
        datasets[val.project_id] = val.project_name;
      });
    }
    const metricName = this.props.krText;
    if (
      typeof metricName === "undefined" ||
      metricName == null ||
      metricName == ""
    ) {
      errors["metricName"] = true;
      this.props.showMetricNameErr();
    }
    if (this.state.jira.checkRepos.length === 0) {
      if (_this.state.selectedType === "basic") {
        errors["projectSelectionErr"] = true;
      }
    }
    if (!this.state.jqlCompleteValidated) {
      if (_this.state.selectedType === "jql") {
        errors["qCompleteError"] = true;
      }
    }
    if (!this.state.jqlInCompleteValidated) {
      if (_this.state.selectedType === "jql") {
        errors["qInCompleteError"] = true;
      }
    }

    let realErrorState =
      Object.keys(_this.state.errors).filter(val => val === true).length > 0
        ? true
        : false;
    if (Object.keys(errors).length || realErrorState) {
      this.setState({
        errors: {
          ..._this.state.errors,
          ...errors
        }
      });
      if (errors && errors.metricName) {
        $('.krRightPaneContent').parent().animate({ scrollTop: 0 });
      } else if (errors.projectSelectionErr) {
        $('.krRightPaneContent').parent().animate({ scrollTop: $(".krRightPaneContent")[0].scrollHeight - 150 });
      } else if (errors.qCompleteError || errors.qInCompleteError) {
        $('.krRightPaneContent').parent().animate({ scrollTop: $(".krRightPaneContent")[0].scrollHeight - 400 });
      }
    } else {
      let params = {};
      let _this = this;
      params.ext_app_id = "5";
      params.ext_source_name = metricName;
      params.isQuarter  = props.isQuarter;
      params.kr_duration = props.kr_duration;
      params.description = $("#metric-name-note").val();
      params.source = "8";
      params.real_owner = this.props.realOwner.id;
      let coOwners = props.coOwners && props.coOwners.length > 0 ? props.coOwners : [];
			params.coOwners = coOwners.length > 0 ? Array.prototype.map
			  .call(coOwners, s => s.id)
			  .toString() : '';
      params.progress_consider = _this.state.exclude ? 0 : 1;
      params.active_sprint = _this.state.activeSprints ? 1 : 0;
      params.customField=JSON.stringify(this.props.customFieldsData);

      let teaMperArr = [], bizPerArr = [];
      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
        if (Array.isArray(permission_teams) && permission_teams.length) {
          teaMperArr = permission_teams.map(val => val.id);
        }
        if (Array.isArray(permission_biz) && permission_biz.length) {
          bizPerArr = permission_biz.map(val => val.id);
        }
      } else {
        teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
        bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
      }
      params.permission_teams = teaMperArr;
      params.permission_biz = bizPerArr;

      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        params.permission = this.props.goalDetails.permission;
      } else {
        params.permission = Array.prototype.map
          .call(this.state.permissionstate, s => s)
          .toString(); // "A,B,C";
      }

      if (_this.props.item && _this.props.item.id) {
        params.id = _this.props.item.id;
      }
      if (_this.state.selectedType == "jql") {
        params.ext_source_jira = {
          qcomplete:
            _this.state.jqlQCompContent.length > 0
              ? _this.state.jqlQCompContent
              : "",
          qincomplete:
            _this.state.jqlQInCompContent.length > 0
              ? _this.state.jqlQInCompContent
              : "",
          qprogress: _this.state.jqlSelectedType,
          qtype: _this.state.selectedType
        };
      } else if (_this.state.selectedType == "basic") {
        params.project_names = datasets;
        params.project_ids = this.state.jira.checkRepos;
        params.ext_source_jira = {
          qcomplete: "",
          qincomplete: "",
          qprogress: "",
          qtype: _this.state.selectedType
        };
      }
      let goalId = this.props.goalDetails.id;
      let { actions } = this.props;
      let krAlignSel = this.state.krAlingSelected;
      let dependentKrsSel = this.state.krDependenciesSelected;
      let krAligns = [];
      let dependentKrs = [];

      if (Object.keys(krAlignSel).length > 0) {
        krAlignSel.map(item => {
          krAligns.push(item.id);
        });
      }

      if (Object.keys(dependentKrsSel).length > 0) {
        dependentKrsSel.map(item => {
          dependentKrs.push(item.id);
        });
      }
      params["nested_krs"] = constructNestedKRPayload(this.props);
      params.krAligns = krAligns;
      let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
      let tagids=this.state.tags.length ? this.state.tags : ['']
      let finalTagsIds = [...nlpIds,...tagids]
      params.krTagIds = finalTagsIds;
      params.dependentKr = dependentKrs;
      params.retainUpdates = this.state.selectedTypeOpt ? this.state.selectedTypeOpt : '' ;
      if(this.props.isChildKr && this.props.fromParentKr){
        params.duration = this.props.childKrDuration;
        params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
        params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
        params.coOwnersDetails = coOwners?.length > 0 ? coOwners : [];
        if(this.props.item.parent){
          params.parent = this.props.item.parent;
        }
        this.props.saveNestedKr(params, this.props.nestedKrIndex, this.props.nestedKrAction);
      } else if(this.props.mitChildKr){
        params.duration = this.props.childKrDuration;
        params.real_owner_fullname = this.props.showRealOwner ? this.props.realOwner.name : "";
        params.real_owner_picture = this.props.showRealOwner ? this.props.realOwner.avatar : "";
        params.real_owner_pic = this.props.showRealOwner ? this.props.realOwner.avatar : "";
        params.end_date = this.props.item.end_date;
        params.start_date = this.props.item.start_date;
        params.target = this.props.item.target  || 0;
        params.name = metricName;
        // params.checkRepos = this.state.jira.checkRepos;
        params.metricJira = { 
                              ids : this.state.jira.checkRepos,
                              active_sprint : params.active_sprint,
                              qtype: this.state.selectedType
                            };
        this.props.saveQuarterlyKR(params, this.props.mitIndex);
        this.props.closeKrRightPane();
      } else{
        if(this.props.item.parent){
          params.start_date = this.props.childKrDuration.start ;
          params.end_date = this.props.childKrDuration.end;
          params.parent = this.props.item.parent;
        }
        params.customField=JSON.stringify(this.props.customFieldsData);
        reactLoader();
        this.GoalServices.addEditKr({ goalId: goalId, metric: params }).then(
          response => {
            removeReactLoader();
            if (response.data.data) {
              this.setState({ confirmPopup: false, externalSource: false });
              if (!this.props.onlyMetEdit) {
                let result = response.data.data;
                let krWeightage = null;
                if (result.krWeightage) {
                  krWeightage = result.krWeightage;
                  delete result['krWeightage'];
                }
                if(result.parent){
                  actions.addUpdateNestedKr(result)
                }else{
                  actions.addNewKr(response.data.data);
                }
                
                if (krWeightage) {
                  _this.props.MetricChangeWeight(krWeightage);
                }
              }
              // this.GoalServices.triggerGoalMetricDetails({ goalId });
              _this.props.closeKrRightPane(true);
            }
          }
        );
      }
    }
  }

  handleCancel() {
    this.props.closeKrRightPane(false, this.props.item.id ? this.props.item.id : '');
  }

  onqCompleteOutsideClick(e) {
    if (this.state.selectedType === 'jql' && this.state.selectedInstance.token_state === 'valid') {
      const qcompleteVal = this.firstTextArea.refs.qCompVal.value.trim();
      const qIncompleteVal = this.secondTextArea.refs.qInCompVal.value.trim();
      if (!this.state.jqlCompleteValidated) {
        if (
          !$('.jiraQuantityComplete').is(e.target)
          && !$('.Cancel').is(e.target)
        ) {
          if (
            qcompleteVal != null
            && qcompleteVal != undefined
            && qcompleteVal.length > 0
          ) {
            this.setState({ jqlCompleteSpinner: true });
            this.GoalServices.getQueryValidationforJira({
              qcomplete: qcompleteVal,
              qincomplete: '',
              progress:
                this.state.jqlSelectedType.length > 0
                  ? this.state.jqlSelectedType
                  : '',
              instance_url: this.state.selectedInstance.belong_to,
            }, { timeout: 0 }).then((response) => {
              if (response.data.data) {
                if (
                  response.data.data.qcomplete
                  && response.data.data.qcomplete.status === 'success'
                ) {
                  this.setState({
                    errors: {
                      ...this.state.errors,
                      qCompleteError: false,
                    },
                    jqlQCompContent: qcompleteVal,
                    jqlCompleteValidated: true,
                    jqlCompleteSpinner: false,
                    jqlCompleteTotalCount: response.data.data.qcomplete.totalCount
                      ? response.data.data.totalCount
                      : 0,
                  });
                } else {
                  this.setState({
                    errors: {
                      ...this.state.errors,
                      qCompleteError: true,
                    },
                    jqlQCompContent: '',
                    jqlCompleteSpinner: false,
                    jqlCompleteValidated: false,
                  });
                }
              }
            }).catch((error) => {
              this.setState({
                errors: {
                  ...this.state.errors,
                  jql: true,
                },
                jqlInCompleteSpinner: false,
                jqlInCompleteValidated: false,
              });
            });
          }
        }
      }
      if (!this.state.jqlInCompleteValidated) {
        if (
          !$('.jiraQuantityInComplete').is(e.target)
          && !$('.Cancel').is(e.target)
        ) {
          if (
            qIncompleteVal != null
            && qIncompleteVal != undefined
            && qIncompleteVal.length > 0
          ) {
            this.setState({ jqlInCompleteSpinner: true });
            this.GoalServices.getQueryValidationforJira({
              qcomplete: '',
              qincomplete: qIncompleteVal,
              progress:
                this.state.jqlSelectedType.length > 0
                  ? this.state.jqlSelectedType
                  : '',
              instance_url: this.state.selectedInstance.belong_to,
            }, { timeout: 0 }).then((response) => {
              if (response.data.data) {
                if (
                  response.data.data.qincomplete
                  && response.data.data.qincomplete.status === 'success'
                ) {
                  this.setState({
                    errors: {
                      ...this.state.errors,
                      qInCompleteError: false,
                    },
                    jqlQInCompContent: qIncompleteVal,
                    jqlInCompleteValidated: true,
                    jqlInCompleteSpinner: false,
                    jqlInCompleteTotalCount: response.data.data.qincomplete.totalCount
                      ? response.data.data.qincomplete.totalCount
                      : 0,
                  });
                } else {
                  this.setState({
                    errors: {
                      ...this.state.errors,
                      qInCompleteError: true,
                    },
                    jqlQCompContent: '',
                    jqlInCompleteSpinner: false,
                    jqlInCompleteValidated: false,
                  });
                }
              }
            }).catch((error) => {
              this.setState({
                errors: {
                  ...this.state.errors,
                  jql: true,
                },
                jqlInCompleteSpinner: false,
                jqlInCompleteValidated: false,
              });
            });
          }
        }
      }
    }
  }

  handleFontChangeTextOne(e) {
    document.getElementById('jiraQ-Complete').style.fontStyle = 'normal';
    this.setState({
      errors: {
        ...this.state.errors,
        qCompleteError: false,
      },
    });
  }

  handleFontChangeTextTwo(e) {
    document.getElementById('jiraQ-Complete').style.fontStyle = 'normal';
    this.setState({
      errors: {
        ...this.state.errors,
        qInCompleteError: false,
      },
    });
  }

  formatInstancesForDropdown(instances, value = undefined) {
    return instances.map((instance, i) => {
      return { ...instance, name: instance.belong_to, value: value || i };
    });
  }

  handleInstanceChange(event, item) {
    this.GoalServices.getExtProjects({
      app: 'jira',
      metric_id: 1,
      instance_url: item.belong_to,
    })
      .then((res) => {
        const props = this.props;
        if (res && res.data && res.data.data) {
          let checkedProjects;
          if (item.belong_to === this.props.item.instance_url) {
            // Fill in saved checked boxes if going back to original instance_url
            checkedProjects = this.props.item.metricJira.ids;
          } else checkedProjects = [];
          this.setState({
            selectedInstance: item,
            jira: {
              ...this.state.jira,
              jiraRepoData: res.data.data,
              checkRepos: checkedProjects,
            },
            jqlCompleteValidated: false,
            jqlInCompleteValidated: false,
            jqlQInCompContent: '',
          });
          this.firstTextArea.refs.qCompVal.value = '';
          this.secondTextArea.refs.qInCompVal.value = '';
        } else {
          // Cannot connect / auth disabled
          this.setState({
            selectedInstance: item,
            jira: {
              ...this.state.jira,
              jiraRepoData: [],
              checkRepos: [],
            },
          });
        }
      });
  }

  updateInstances(instanceUrl, callBackResponse = null) {
    this.GoalServices.getExtProjects({
      app: 'jira',
      metric_id: 1,
      instance_url: instanceUrl,
    })
      .then((response) => {
        if (response && response.data.data) {
          const formattedData = this.formatInstancesForDropdown([{ belong_to: instanceUrl, token_state: 'valid' }], this.state.jira.instances.length);
          this.setState({
            jira: {
              ...this.state.jira,
              instances: (callBackResponse && typeof callBackResponse.existing_instance !== undefined && callBackResponse.existing_instance) ? this.state.jira.instances : this.state.jira.instances.concat(formattedData),
              jiraRepoData: response.data.data,
              checkRepos: [],
            },
            selectedInstance: formattedData[0],
            jqlCompleteValidated: false,
            jqlInCompleteValidated: false,
            jqlQInCompContent: '',
          });
          this.firstTextArea.refs.qCompVal.value = '';
          this.secondTextArea.refs.qInCompVal.value = '';
        }
      });
  }

  saveAlignArr(alignData) {
    this.setState({
      krAlingSelected: alignData
    })
  }
  saveDependentArr(dependentData) {
    this.setState({
      krDependenciesSelected: dependentData
    })
  }
  saveTag = (childData) =>{
		this.setState({tags:childData})
	}
  changeRadioOpt(value) {
		const valueToSet = value
		this.setState(
		  {
        selectedTypeOpt: valueToSet
		  }
		)
	}
  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }

  isSaveCustom(isVal){
    let arr=[];
    let j=0;
    let keyArrCategory=[]
    let valArray = []
    isVal && Object.keys(isVal).forEach((v)=>{
      j++;
      isVal[v]["customFields"]&&
      Object.keys(isVal[v]["customFields"]).forEach(objv=>{
        keyArrCategory.push(objv)
        if(isVal[v]["customFields"][objv]['is_required']=='1'
        &&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
        ){
             arr.push(objv,v)
            }
        if(isVal[v]["customFields"][objv]["text"]){
          valArray.push(isVal[v]["customFields"][objv]["text"])
        }else{
          valArray.push('')
        }   
      })
      if(j==Object.keys(isVal).length){
        this.setState({isRequirdCustomOkr:[...arr]})
      }  
      let finalDataArray=[]
      for(let i=0;i<valArray.length;i++){
        if(Array.isArray(valArray[i])){
          valArray[i].forEach(val => {
            finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
          })
        }
        else{
          finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
        }
         
      }
      const tempData=finalDataArray
    })
    
  }

  isRequiredCustomOkrFiled(isVal,id){
    let cust_id=this.state.isCustomSave.find((u) => u == id);
    let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
    let fr= ar.filter(
        (u) => u != cust_id
      )
    this.setState({isCustomSave:fr})
    this.isSaveCustom(isVal)
    this.setState({customInputData:isVal})
  }

  renderError(field) {
    return (
      <ErrorTextComp key={field} errors={this.state.errors} field={field} />
    );
  }



  render() {
    const {t} = this.props;
    const errors = this.state.errors;
    let qCompValidationText = '';
    let validationClassComp = '';
    if (this.state.jqlCompleteValidated) {
      qCompValidationText = `${t('JQL Verified')} | ${t('Issue Count')}: ${
        this.state.jqlCompleteTotalCount
        }`;
    } else if (this.state.jqlCompleteSpinner) {
      qCompValidationText = `${t('Validating')}...`;
      validationClassComp = 'jiraQueryValidation';
    } else if (this.state.errors.jql) {
      qCompValidationText = t("Unable to contact Jira servers")
      validationClassComp = 'gray-error';
    } else if (
      !this.state.jqlCompleteValidated
      || !this.state.jqlCompleteSpinner
    ) {
      qCompValidationText = '';
      validationClassComp = '';
    }
    let qInCompValidationText = '';
    let validationClassInComp = '';
    if (this.state.jqlInCompleteValidated) {
      qInCompValidationText = `${t('JQL Verified')} | ${t('Issue Count')}: ${
        this.state.jqlInCompleteTotalCount
        }`;
    } else if (this.state.jqlInCompleteSpinner) {
      qInCompValidationText = `${t('Validating')}...`;
      validationClassInComp = 'jiraQueryValidation';
    } else if (this.state.errors.jql) {
      qInCompValidationText = t("Unable to contact Jira servers")
      validationClassInComp = 'gray-error';
    } else {
      qInCompValidationText = '';
      validationClassInComp = '';
    }

    const openInNewTab = (url) => {
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    }

    let defChecked = false;
    if (Object.keys(this.props.item).length > 0 && this.props.item.ext_app_id == '5' && this.props.kpiType == 'jira') {
      if (this.props.item.progress_consider == '0' || this.props.item.progress_consider == false) {
        defChecked = true;
      }
    }

    return (
      <div className="jira-integration-wrapper">
        <div className="JiraFirstQuestion">
          {t('How do you want to get issue completion data from JIRA?')}
        </div>
        <div className="JiraRadioAndSelectionConatiner">
          <RadioButComp
            id="jiraRadioPerc"
            label={t("Percentage of completed issues within specific projects")}
            classDefined="paddingLeft30"
            subclassDefined="radioMarginClass"
            onClick={this.changeRadio}
            radioButProps={{
              name: 'SetFirst',
              defaultChecked: this.state.selectedType === 'basic',
            }}
          />
        </div>
        <div className="JiraRadioAndSelectionConatiner marginTop4point5">
          <RadioButComp
            id="jiraRadioJQL"
            label={t("Advanced JQL query")}
            classDefined="paddingLeft30"
            subclassDefined="radioMarginClass"
            onClick={this.changeRadio}
            radioButProps={{
              name: 'SetFirst',
              defaultChecked: this.state.selectedType === 'jql',
            }}
          />
        </div>

        {!!this.state.jira.instances.length && !!this.state.selectedInstance && (
          <>
            <div className="JiraFirstQuestion marginTopto27">{`${t('Selected Jira Instance')}:`}</div>
            <div className="jira-dropdown-container">
              <DropdownComp
                options={this.state.jira.instances} // Replace with props later, might need to make a new object with values and names
                defaultValue={this.state.selectedInstance.value}
                onChange={this.handleInstanceChange} // Should make another api call to fetch all the other projects
                wrapperClass="add-okrs-dropdown-wrapper popup-dropdown-wrapper"
                appendId="selected-jira"
              />
              <div
                onClick={() => this.state.jira.instances[0]['oauth2_url']? openInNewTab(this.state.jira.instances[0]['oauth2_url']): this.setState({ showPopup: true })}
                className="add-new-instance"
              >+ {t('Connect to new instance')}
              </div>
            </div>
            {this.state.selectedInstance.token_state !== 'valid' && (
              <div className="amber-text warning-error">
                <i className="icon icon-warning_14px_amber" />
                {t('The Jira instance associated with this key result has been disabled and/or the token has been revoked.')}
            </div>
            )}
          </>
        )}

        {this.state.errors.instance &&
          <div className="gray-error">{t('Unable to contact Jira servers, try again later.')}</div>
        }

        {this.state.selectedType === 'basic' && (
          <div>
            <div className="Jirasingle-checkbox-desc-container">
              <CheckBoxComp
                id="jira_check_sprints"
                label={t("Only include issues from active sprints within projects")}
                onChange={this.changeActiveSprint}
                checkboxProps={{
                  defaultChecked: this.props.item
                    ? this.props.item.metricJira
                      ? this.props.item.metricJira.active_sprint
                        ? this.props.item.metricJira.active_sprint == '1'
                        : false
                      : false
                    : false,
                }}
              />
            </div>

            <div className="JiraFirstQuestion marginTopto27">
              {t('Select which projects you want to measure')} <span className="colorTheStar">*</span>
            </div>
            {this.state.errors.projects && (
              <div className="gray-error">{t('Unable to contact Jira servers, try again later.')}</div>
            )}
            <div className="JiraRepoCheckboxContainer">
              {this.state.jira
                && this.state.jira.jiraRepoData
                && this.state.jira.jiraRepoData.map((val) => (
                  // Need to specify from which instance its from, since project id is unique only to
                  // projects and not across the whole spectrum.
                  <CheckBoxComp
                    id={`jiraSelect${this.props.isChildKr ? "-child" : ""} ${val.project_id}`}
                    key={val.project_id}
                    label={val.project_name}
                    onChange={this.changeRepoSelection}
                    item={val}
                    checkboxProps={{
                      checked: this.state.jira
                        ? this.state.jira.checkRepos
                          ? !!(this.state.jira.checkRepos.length > 0
                            && this.state.jira.checkRepos.includes(val.project_id))
                          : false
                        : false,
                    }}
                    classDefined="jiraLable"
                    labelStyle={{
                      verticalAlign: 'top',
                    }}
                    subclassDefined="jiraChecboxkWrap"
                  />
                ))}
            </div>
            {errors
              && (typeof errors.projectSelectionErr !== 'undefined'
                && errors.projectSelectionErr == true) ? (
                <div className="alertJira">
                  <span className="alertJiraIcon" />
                  <span className="alertJiraDesc">{t('Select a project')}</span>
                </div>
              ) : (
                ''
              )}
          </div>
        )}
        {this.state.selectedType === 'jql' && (
          <div>
            <TextareaFieldComp
              ref={(ref) => (this.secondTextArea = ref)}
              wrapperClass="jiraTextAreaTwo"
              label={t("JQL query for all issues") +':'}
              labelClass="jiraTextAreaLabel"
              InputTypeFaceText="*"
              textAreaWrapper={`${`jiraSecondTextArea${
                this.state.errors.qInCompleteError === true
                && ' validateQComplete'}`}`}
              distinguishedClass="jiraQuantityInComplete"
              distinguishedID="jiraQ-InComplete"
              textareaRef="qInCompVal"
              validationClass={validationClassInComp}
              validationText={qInCompValidationText}
              textareaProps={{
                placeholder:
                  `${t('Add your JQL query to pull of the issues that need to counted.')} ${t('You can use any JIRA attributes to narrow down the results.')} ${t('Ex')}:${t('project')} = ${t('K2 AND Sprint')} = 42`,
                onChange: this.onDoneQueryChange,
                defaultValue:
                  this.state.jqlQInCompContent.length > 0
                    ? this.state.jqlQInCompContent
                    : '',
              }}
            />
            {errors
              && (typeof errors.qInCompleteError !== 'undefined'
                && errors.qInCompleteError == true) ? (
                <div className="alertJira">
                  <span className="alertJiraIcon" />
                  <span className="alertJiraDesc">{t('Enter a valid JQL query')}</span>
                </div>
              ) : (
                ''
              )}
            <TextareaFieldComp
              ref={(ref) => (this.firstTextArea = ref)}
              wrapperClass="jiraTextAreaWrapper"
              label={t("JQL query issues that count as completed")+':'}
              labelClass="jiraTextAreaLabel"
              InputTypeFaceText="*"
              textAreaWrapper={`${`jiraTextArea${
                this.state.errors
                && this.state.errors.qCompleteError === true
                && ' validateQComplete'}`}`}
              distinguishedClass="jiraQuantityComplete"
              distinguishedID="jiraQ-Complete"
              textareaRef="qCompVal"
              validationClass={validationClassComp}
              validationText={qCompValidationText}
              textareaProps={{
                placeholder: `${t('Add your JQL query to pull issues that are complete, whether that is status, resolution, etc.')} ${t('Ex')}: ${t('project')} = ${t('WW AND Sprint')} = 42 ${t('AND')} (${t('Resolution')} = ${t('Done OR status')} = ${t('Fixed')}`,
                onChange: this.onJqlChange,
                defaultValue:
                  this.state.jqlQCompContent.length > 0
                    ? this.state.jqlQCompContent
                    : '',
              }}
            />
            {errors
              && (typeof errors.qCompleteError !== 'undefined'
                && errors.qCompleteError == true) ? (
                <div className="alertJira">
                  <span className="alertJiraIcon" />
                  <span className="alertJiraDesc">{t('Enter a valid done query')}</span>
                </div>
              ) : (
                ''
              )}

            <div className="JiraSecondQuestion">
              {t('Measure progress as')} <span className="colorTheStar">*</span>
            </div>
            <div className="JiraSecondRadioAndSelectionConatiner">
              <RadioButComp
                id="percentage"
                label={t("Percentage complete")}
                classDefined="paddingLeft30"
                subclassDefined="radioMarginClass"
                onClick={this.changeJqlRadio}
                radioButProps={{
                  name: 'SetSecond',
                  defaultChecked: this.state.jqlSelectedType === 'percentage',
                }}
              />
            </div>
            <div className="JiraSecondRadioAndSelectionConatiner marginTopto5">
              <RadioButComp
                id="quantity"
                label={t("Quantity complete")}
                classDefined="paddingLeft30"
                subclassDefined="radioMarginClass"
                onClick={this.changeJqlRadio}
                radioButProps={{
                  name: 'SetSecond',
                  defaultChecked: this.state.jqlSelectedType === 'quantity',
                }}
              />
            </div>
          </div>
        )}
         {(this.props.customData && Object.keys(this.props.customData).length > 0 && !this.props.mitChildKr ) && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
            {  ((this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields) && !this.props.mitChildKr )&& 
                    <Customokr
                      customData={this.props.customData}
                      isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
                      onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
                      customFiledRequired={true}
                      renderError={this.renderError}
                      isCustomSave={this.state.isCustomSave}
                    />
            }
        {!this.props.isChildKr && !this.props.mitChildKr && this.state.selectedType === 'basic' && (
          <div className="breakline marginTop21" />
        )}
        {!this.props.isChildKr &&  this.state.selectedType === 'jql' && !this.props.mitChildKr && (
          <div className="breakline marginTop6" />
        )}
        {    
          (this.props.addOkrData.display_nested_kr && 
          !this.props.isChildKr && !this.props.mitChildKr &&
          Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
          <NestedInlineComp
          {...this.props}
          actions = {this.props.actions}
          nested_krs = {this.props.nested_krs}
          updateNestedKrs = {this.props.updateNestedKrs}
          />
        }
        <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
        {!this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.validateJiraKr}/>}
        {
          !this.props.isChildKr && !this.props.mitChildKr &&
          <> 
            <KrAlignDependance {...this.props}
            saveDependentArr={this.saveDependentArr}
            saveAlignArr={this.saveAlignArr}
            krAlingArr={this.props.item.kr_aligns}
            krDependenciesArr={this.props.item.kr_dependent} 
            />
            <AddKrTag metric={this.props.item} goalId={this.props.goalDetails.id} taghandler={this.saveTag}
            nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
            />
            <div className="fieldcontent jiraExclude">
              <CheckBoxComp
                label={t(`Exclude from objective progress calculation`)}
                id="jiraExcludeObj"
                subclassDefined = "displayInLineBlk"
                onChange={this.changeExclude}
                checkboxProps={{ defaultChecked: defChecked }}
              />
            </div>
          </>
        }
        
        {this.props.goalDetails && this.props.goalDetails.all_metrics == '0' && !this.props.mitChildKr && (
          <div className="pT10">
            <div className="viewPermissionArea">
              <span>
                {t('View permissions in addition to')}{' '}
                {this.props.goalDetails.type == 1 ? ' team ' : ' owner '}
                <div
                  className="metricTargetHelptext permissionHelpText"
                  onMouseEnter={(event) => {
                    this.setState({ permissionHelpPopUp: true });
                  }}
                  onMouseLeave={(event) => {
                    this.setState({ permissionHelpPopUp: false });
                  }}
                />
                {this.state.permissionHelpPopUp && (
                  <div className="basic-popup">
                    {t('You can give your whole organization permission to view your Key Result, or just your team and managers')}
              </div>
                )}
              </span>
            </div>
            <div className="pT10">
              <PermissionComp
                {...this.props}
                teamPermissionData={this.teamPermissionData}
                bizPermissionData={this.bizPermissionData}
                permissionData={this.permissionData}
                hide={false}
              />
            </div>
          </div>
        )}
        {
          this.state.confirmPopup &&
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.saveItems}
            id=""
            title={t(`Save Key Result with New Data Type`)}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={t(`Are you sure you want to save this key result with the new data type you selected? This will get rid of past key result data.`)}
            buttonText={t("Save")}
          />

        }
        {
          this.state.externalSource  &&
          <RetainUpdateModal
                selectedType={this.state.selectedTypeOpt}
                changeRadio={this.changeRadioOpt}
                exitDeleteModal={this.exitDeleteModal}
                deleteItems={this.saveItems}
                titleRetain={this.state.titleRetain ? this.state.titleRetain :  t("Save key result with new data type" )}
                contentRetain ={this.state.titleRetain ?  t("Are you sure you want to change the update frequency of this key result?") : t("Are you sure you want to save this key result with the new data type selected?")}
              />
        }
        {this.state.showPopup && (
          <JiraIntegrationPopup
            action="add"
            closePopup={() => this.setState({ showPopup: false })}
            updateParentState={this.updateInstances}
          />
        )}
      </div>
    );
  }
}
export default withTranslation()(JiraPostLogin); 
